import { colors } from 'fitify-ui/src/theme/colors'

import {
  getActiveDots,
  getIntensityColor,
  INTENSITY_DOTS,
  type IntensityVariant,
} from '../Muscles.Utils'

import {
  StyledIntensityBar,
  StyledIntensityDot,
} from './IntensityIndicator.Styled'

type Props = {
  intensity: number
  variant: IntensityVariant
}

export const IntensityIndicator = ({ intensity, variant }: Props) => {
  const activeDots = getActiveDots(intensity)

  return (
    <StyledIntensityBar>
      {Array.from({ length: INTENSITY_DOTS }, (_, index) => {
        const isActive = index < activeDots

        return (
          <StyledIntensityDot
            key={index}
            $backgroundColor={
              isActive ? getIntensityColor(variant, intensity) : colors.Gray200
            }
          />
        )
      })}
    </StyledIntensityBar>
  )
}
